export default {
	colors: {
		transparent: 'transparent',
		black: '#000',
		white: '#fff',
		gray: {
			400: '#f5f5f5',
			500: '#e5e5e5',
			600: '#d5d5d5',
			700: '#c5c5c5',
			900: '#333'
		},
		blue: {
			700: '#004976',
			800: '#00314F'
		},
		red: {
			500: '#980000',
			600: '#880000'
		}
	},
	breakpoints: ['0em', '30em', '48em', '62em', '80em', '96em']
};
